import React from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { t } from '../i18n/i18n'
dayjs.extend(utc)

export const formatToSwedishCrowns = (cost: string | number) => {
   if (cost || cost === 0) return new Intl.NumberFormat('sv-SE').format(Number(cost))
   return null
}

export const formatDate = (date: Date | string, withTime?: boolean) => {
   const local = dayjs.utc(date).local()
   return withTime ? local.format('YYYY-MM-DD HH:mm') : local.format('YYYY-MM-DD')
}

export const compareByDate = (a: string | Date, b: string | Date) => dayjs.utc(a).valueOf() - dayjs.utc(b).valueOf()

export const summarizeFieldValues = (items: any[], field: string) => {
   const values = items.map((item) => (item[field] as number | null) ?? null)

   return values.every((value) => value === null) ? null : values.reduce((acc, curr) => acc + curr, 0)
}

export const valueOrFallback = (value: string | null) => {
   if (value === null || value === undefined || value === '') return <i>{t('NoValueSet')}</i>
   return <>{value}</>
}
